import React from 'react'
import { observer } from 'mobx-react'

const QuestionChallengeView = ({ challenge }) => (
  <div className="question-challenge">
    <input
      type="text"
      className="input"
      placeholder="Write your answer here"
      value={challenge.answer}
      onChange={e => challenge.setAnswer(e.target.value)}
    />
  </div>
)

export default observer(QuestionChallengeView)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/QuestionChallenge/View.jsx